import { render, staticRenderFns } from "./ModifyDesign.vue?vue&type=template&id=6a901352&scoped=true"
import script from "./ModifyDesign.vue?vue&type=script&lang=js"
export * from "./ModifyDesign.vue?vue&type=script&lang=js"
import style0 from "./ModifyDesign.vue?vue&type=style&index=0&id=6a901352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a901352",
  null
  
)

export default component.exports